// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SavedView  {
    _originalTypeClassName = "Loom.BO.SavedView";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SavedView.translate = translateService;
}
this.Id = null;
this.ListKey = null;
this.Name = null;
this.IsDefault = false;
this.Filters = null;
this.Sort = null;
this.Display = null;
this.VisibleColumns = null;
this.PageSize = null;
this.CreatedAt = null;
this.UpdatedAt = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
ListKey:any;
Name:any;
IsDefault:any;
Filters:any;
Sort:any;
Display:any;
VisibleColumns:any;
PageSize:any;
CreatedAt:any;
UpdatedAt:any;
Owner:any;
static setOwner = ($this, value) => {
var oldValue = $this.Owner;
$this.Owner = value;
if (value != null) {
if (oldValue != null) {
Domain.UserAccount.removeSavedViews(oldValue, $this);
}
Domain.UserAccount.addSavedViews(value, $this);
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}